var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteAccountManagement = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5101 21.99C20.7001 21.99 22.7601 21.14 24.3101 19.59C25.8601 18.04 26.7101 15.98 26.7101 13.79C26.7101 11.6 25.8601 9.54003 24.3101 7.99003C22.7601 6.44003 20.7001 5.59003 18.5101 5.59003C16.3201 5.59003 14.2601 6.44003 12.7101 7.99003C11.1601 9.54003 10.3101 11.6 10.3101 13.79C10.3101 15.98 11.1601 18.04 12.7101 19.59C14.2601 21.14 16.3201 21.99 18.5101 21.99Z",
    fill: "url(#paint0_linear_1868_54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.54 25.0401C31 25.0401 31.46 25.0901 31.9 25.1801C31.81 25.0501 31.73 24.9201 31.63 24.7901C30.21 22.9501 28.18 21.6901 25.59 21.0401C25.39 20.9901 25.17 21.0401 25.01 21.1801C23.21 22.7601 20.9 23.6301 18.51 23.6301C16.12 23.6301 13.81 22.7601 12.01 21.1801C11.85 21.0401 11.64 20.9901 11.43 21.0401C8.84 21.6901 6.81 22.9501 5.39 24.7901C3.8 26.8501 3 29.6401 3 33.0801C3 33.3601 3.18 33.5901 3.42 33.6801C7.44 35.2601 12.79 36.1401 18.51 36.1401C20.71 36.1401 22.86 36.0101 24.91 35.7601C24.15 34.6601 23.7 33.3201 23.7 31.8801C23.7 28.1001 26.76 25.0401 30.54 25.0401Z",
    fill: "url(#paint1_linear_1868_54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4499 31.4101L33.9099 28.9501C34.1599 28.7001 34.1599 28.2801 33.9099 28.0301C33.6599 27.7801 33.2399 27.7801 32.9899 28.0301L30.5299 30.4901L28.0699 28.0301C27.8199 27.7801 27.3999 27.7801 27.1499 28.0301C26.8999 28.2801 26.8999 28.7001 27.1499 28.9501L29.6099 31.4101L27.1499 33.8701C26.8999 34.1201 26.8999 34.5401 27.1499 34.7901C27.2799 34.9201 27.4399 34.9801 27.6099 34.9801C27.7799 34.9801 27.9399 34.9201 28.0699 34.7901L30.5299 32.3301L32.9899 34.7901C33.1199 34.9201 33.2799 34.9801 33.4499 34.9801C33.6199 34.9801 33.7799 34.9201 33.9099 34.7901C34.1599 34.5401 34.1599 34.1201 33.9099 33.8701L31.4499 31.4101Z",
    fill: "url(#paint2_linear_1868_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1868_54",
    x1: 18.5101,
    y1: 21.99,
    x2: 18.5101,
    y2: 5.59003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED4437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ED2F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1868_54",
    x1: 17.45,
    y1: 36.1401,
    x2: 17.45,
    y2: 21.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED4437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ED2F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1868_54",
    x1: 26.9699,
    y1: 31.4101,
    x2: 34.0999,
    y2: 31.4101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED4437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ED2F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteAccountManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DeleteAccountManagement.7652291e.svg";
export { ForwardRef as ReactComponent };